import React, { Fragment, useCallback, useState } from "react";
import {
  Box,
  Flex,
  Icon,
  Select,
  Spinner,
  Stack,
  Text,
} from "@storyofams/react-ui";

import { usePostHog } from "posthog-js/react";
import styled from "styled-components";
import { Search } from "~components/common/Icons";
import { Button, Divider } from "../../../../components";
import { Question } from "./Question";
import { QuestionForm } from "./QuestionForm";

export const StyledInput = styled(Box)`
  appearance: none;
  display: inline-block;
  background-color: white;
  border-color: ${({ theme }) => theme.colors.grey400};
  border-width: 1px;
  border-style: solid;
  transition: border-color 0.18s ease-in-out, background-color 0.18s ease-in-out;
  text-decoration: none;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey400};
    text-overflow: ellipsis;
  }
`;
const sorting = [
  { value: "rating", asc: false, label: "Hoogste beoordeling" },
  { value: "dateCreated", asc: false, label: "Nieuw - oud" },
];
export const Questions = ({
  productId,
  loadingQuestions,
  questions,
  searchState,
  productTitle,
  setSearchMemo,
  sortingQuestionsState,
  questionSortingMemo,
  children,
}) => {
  const hasQuestions = !!questions && !!questions.length;
  const [isShow, setIsShow] = useState(false);
  const close = useCallback(() => setIsShow(false), [isShow]);
  const posthog = usePostHog();
  return (
    <>
      <Flex
        mt="30px"
        mb="20px"
        flexDirection={["column", "row"]}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text
          fontFamily={"DINPro"}
          fontWeight={700}
          fontSize={"28px"}
          mb={[2, 0]}
        >
          Vragen
        </Text>
        <Button
          display={["block", "none"]}
          width="100%"
          onClick={() => setIsShow((show) => !show)}
        >
          Stel een vraag
        </Button>
        <Flex
          flexDirection={["column", "row"]}
          width={["100%", "auto"]}
          mt={[3, 0]}
        >
          <Box position={"relative"}>
            <StyledInput
              as="input"
              px={2}
              py={1.5}
              pr={5}
              mb={[1.5, 0]}
              mr={[0, 2]}
              fontSize={2}
              height="40px"
              width={["100%", "230px", "282px"]}
              color="black"
              borderRadius="md"
              type="search"
              name="search"
              // onClick={() =>
              //   posthog.capture("Clicked Questions Widget", {
              //     section: "search",
              //   })
              // }
              placeholder="Zoek binnen vragen"
              value={searchState}
              onChange={(e: any) => {
                setSearchMemo(e.target.value);
              }}
            />
            <Icon
              position="absolute"
              right={[2, 3.5]}
              top={[-1, 0]}
              bottom={0}
              color="grey800"
              fontSize={2}
              icon={Search}
            />
          </Box>
          <Select
            value={sortingQuestionsState}
            onChange={(e) => {
              questionSortingMemo(e);
              // posthog.capture("Clicked Reviews Widget", {
              //   section: "Sorting select",
              // });
            }}
            width={["100%", 213]}
            height={40}
            options={sorting}
            placeholder="Selecteer je leeftijdsgroep"
            css={`
              border: 1px solid #c1bebd;
              border-radius: 8px;
              height: 40px;
              min-height: 40px;
              & > div {
                border-radius: 7px !important;
                font-size: 16px;
                transition: border-color 0.18s ease-in-out,
                  background-color 0.18s ease-in-out;
              }
              &:not(:disabled) {
                &:hover,
                &:active,
                &:focus {
                  border-color: black;
                }
              }
              .react-select__option {
                &:hover {
                  background: #f4f3f0;
                }
              }
            `}
          />
        </Flex>
      </Flex>
      <Stack space={1} flexDirection={["column", "row-reverse"]} mt={1}>
        <QuestionForm
          display={[isShow ? "block" : "none", "block"]}
          productId={productId}
          close={close}
          productTitle={productTitle}
          height="fit-content"
          maxWidth={["100%", !loadingQuestions && !hasQuestions ? 450 : 384]}
          mx={!loadingQuestions && !hasQuestions && "auto"}
        />

        <Box flex={1}>
          <Stack space={4} flexDirection="column" pr={[0, 2.5]} flex={1}>
            {loadingQuestions ? (
              <Flex
                height="100%"
                width="100%"
                alignItems="center"
                justifyContent="center"
              >
                <Spinner />
              </Flex>
            ) : (
              questions?.map((question, i) => (
                <Question key={question?.id} {...question} isFirst={i === 0} />
              ))
            )}
          </Stack>

          {children}
          {!hasQuestions && !loadingQuestions && (
            <Text>
              Oeps! Niemand heeft deze vraag tot nu toe gesteld, waarom stel je
              hem niet zelf?
            </Text>
          )}
        </Box>
      </Stack>
    </>
  );
};
